export default (team, family) => {
  if (team) {
    const otherFamily = team.find(item => item.familyId !== family._id);
      if (otherFamily) 
        return false ;
      else return true;
  }
  else return null;
};
